import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 11h-8v6h8v-6zm4 10V3H1v18h22zm-2-1.98H3V4.97h18v14.05z"
}), 'PictureInPictureAltSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PictureInPictureAltSharp.js
// module id = 5475
// module chunks = 2